import { render, staticRenderFns } from "./MaterialTypeList.vue?vue&type=template&id=1860edae&scoped=true&"
import script from "./MaterialTypeList.vue?vue&type=script&lang=js&"
export * from "./MaterialTypeList.vue?vue&type=script&lang=js&"
import style0 from "./MaterialTypeList.vue?vue&type=style&index=0&id=1860edae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1860edae",
  null
  
)

component.options.__file = "MaterialTypeList.vue"
export default component.exports